import trackingHealthSherpa from 'utils/trackingHealthSherpa'
import updateAnswers from './updateAnswers'
import handleSubmit from './handleSubmit'
import clickEventName from 'utils/DOM/clickEventName'
import { preventOnCloseEvent } from 'core/services/onClose'

function registryListenersDOM(controller) {
  $(document.body)
    .on('change', '[type=radio]', updateAnswers)
    .on(clickEventName, '#submit', e => handleSubmit(e, controller))
    .on(clickEventName, '#sherpa-link', trackingHealthSherpa)
    .on(clickEventName, '#header-modal-submit', e => handleSubmit(e, controller, true))
    .on(clickEventName, '#header-start-chat', e => handleSubmit(e, controller, true))
    .on(clickEventName, '.ProgressBar__link', function () {
      preventOnCloseEvent()
    })
}

export default registryListenersDOM
